import React, { useEffect, useState } from "react";
import Section from "components/Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "components/SectionHeader";
import AddCarForm from "components/dashboard/cars/AddCarForm";
import Server from "util/Server";
import CarCard from 'components/forms/CarCard';

function AddCarSection(props) {
  const [car, setCar] = useState(null);
  const { carId } = props;

  const loadCar = async () => {
    if (carId) {
      try {
        const response = await Server().getCarById(carId);
        const { status, payload } = response;
        if (status.value === true) {
          setCar(payload);
        }
      } catch (e) {
        console.log('failure happened');
      }
    }
  }

  useEffect(() => {
    loadCar();
  }, [carId])

  if (!car && carId) {
    return null;
  }

  return (
    <Section
      bg={props.bg}
      textColor={props.textColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container
        style={{
          maxWidth: "850px",
        }}
      >
        {car && <CarCard
          carId={carId}
        />}
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={2}
          spaced={true}
          className="text-center"
        />
        <AddCarForm
          showNameField={props.showNameField}
          buttonText={props.buttonText}
          buttonColor={props.buttonColor}
          onSuccessfulCarUpload={props.onSuccessfulCarUpload}
          car={car}
        />
      </Container>
    </Section>
  );
}

export default AddCarSection;
